/**
 * Typography configuration - centralized specs for all typography variants
 */

import type { FontWeight } from './types';

export interface TypographyVariant {
	fontSize: number;
	lineHeight: string;
	defaultWeight: FontWeight;
	element: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
}

/**
 * Typography variant specifications
 */
export const TYPOGRAPHY_VARIANTS: Record<string, TypographyVariant> = {
	// Headings
	Heading3XL: {
		fontSize: 40,
		lineHeight: 'medium',
		defaultWeight: 'semiBold',
		element: 'h1',
	},
	Heading2XL: {
		fontSize: 36,
		lineHeight: 'medium',
		defaultWeight: 'semiBold',
		element: 'h2',
	},
	HeadingXL: {
		fontSize: 32,
		lineHeight: 'medium',
		defaultWeight: 'semiBold',
		element: 'h3',
	},
	HeadingL: {
		fontSize: 24,
		lineHeight: 'small',
		defaultWeight: 'semiBold',
		element: 'h4',
	},
	HeadingM: {
		fontSize: 20,
		lineHeight: 'small',
		defaultWeight: 'semiBold',
		element: 'h5',
	},
	HeadingS: {
		fontSize: 18,
		lineHeight: 'small',
		defaultWeight: 'semiBold',
		element: 'h6',
	},
	HeadingXS: {
		fontSize: 16,
		lineHeight: 'small',
		defaultWeight: 'semiBold',
		element: 'span',
	},
	// Body
	BodyXL: {
		fontSize: 18,
		lineHeight: 'large',
		defaultWeight: 'regular',
		element: 'p',
	},
	BodyL: {
		fontSize: 16,
		lineHeight: 'large',
		defaultWeight: 'regular',
		element: 'p',
	},
	BodyM: {
		fontSize: 14,
		lineHeight: 'large',
		defaultWeight: 'regular',
		element: 'p',
	},
	BodyMSemiBold: {
		fontSize: 14,
		lineHeight: 'large',
		defaultWeight: 'semiBold',
		element: 'p',
	},
	BodyS: {
		fontSize: 12,
		lineHeight: 'large',
		defaultWeight: 'regular',
		element: 'p',
	},
	BodySSemiBold: {
		fontSize: 12,
		lineHeight: 'large',
		defaultWeight: 'semiBold',
		element: 'p',
	},
	BodyXS: {
		fontSize: 11,
		lineHeight: 'large',
		defaultWeight: 'regular',
		element: 'p',
	},
	BodyXSSemiBold: {
		fontSize: 11,
		lineHeight: 'large',
		defaultWeight: 'semiBold',
		element: 'p',
	},
	// Caption
	CaptionS: {
		fontSize: 12,
		lineHeight: 'small',
		defaultWeight: 'regular',
		element: 'p',
	},
	CaptionXS: {
		fontSize: 10,
		lineHeight: 'small',
		defaultWeight: 'regular',
		element: 'p',
	},
} as const;
